import { render, staticRenderFns } from "./LeaderBoardManipulation.vue?vue&type=template&id=2615fc99&scoped=true&"
import script from "./LeaderBoardManipulation.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardManipulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615fc99",
  null
  
)

export default component.exports